import { apiService } from './api'

const BASE = '/gst-reminders'

// Sends must not be auto-retried by the api interceptor, or a slow provider could deliver twice.
const NO_RETRY = { _skipRetry: true }

const unwrap = (res) => res.data

const gstReminderService = {
  getSettings: () => apiService.get(`${BASE}/settings`).then(unwrap),

  saveSettings: (settings) => apiService.put(`${BASE}/settings`, settings).then(unwrap),

  getPeriod: (asOf) => apiService.get(`${BASE}/period`, { params: asOf ? { asOf } : {} }).then(unwrap),

  getStatus: () => apiService.get(`${BASE}/status`).then(unwrap),

  preview: (payload = {}) => apiService.post(`${BASE}/preview`, payload).then(unwrap),

  sendTest: (payload) => apiService.post(`${BASE}/test`, payload, NO_RETRY).then(unwrap),

  sendNow: (payload) => apiService.post(`${BASE}/send-now`, payload, NO_RETRY).then(unwrap),

  listHistory: (params = {}) => apiService.get(`${BASE}/history`, { params }).then(unwrap),

  getHistory: (id) => apiService.get(`${BASE}/history/${id}`).then(unwrap),

  downloadHistory: (id, index = 0) =>
    apiService.download(`${BASE}/history/${id}/download`, { params: { index } }),

  updateItcReview: (vendorInvoiceId, payload) =>
    apiService.patch(`${BASE}/itc/${vendorInvoiceId}`, payload).then(unwrap),
}

export { describeError } from './emailNotificationService'

export default gstReminderService
